import { afterNextRender, Directive, ElementRef, inject } from '@angular/core';

/**
 * Reliably moves focus to the host element once it is rendered.
 *
 * Replacement for the native `autofocus` attribute, which is unreliable for
 * elements inserted dynamically (e.g. a search input inside a dropdown panel
 * that is created with `@if` when the dropdown opens). Using this directive
 * gives deterministic, programmatic focus that satisfies WCAG 2.4.3.
 */
@Directive({
  selector: '[appAutofocus]',
  standalone: true,
})
export class AutofocusDirective {
  private readonly host = inject(ElementRef<HTMLElement>);

  constructor() {
    afterNextRender(() =>
      this.host.nativeElement?.focus({ preventScroll: true }),
    );
  }
}
